export default [{
  head: [{
    left: {
      x: 16,
      y: 8,
      w: 8,
      h: 8,
    },
    right: {
      x: 0,
      y: 8,
      w: 8,
      h: 8,
    },
    top: {
      x: 8,
      y: 0,
      w: 8,
      h: 8,
    },
    bottom: {
      x: 16,
      y: 0,
      w: 8,
      h: 8,
      flipY: true,
    },
    front: {
      x: 8,
      y: 8,
      w: 8,
      h: 8,
    },
    back: {
      x: 24,
      y: 8,
      w: 8,
      h: 8,
    },
  }, {
    left: {
      x: 48,
      y: 8,
      w: 8,
      h: 8,
    },
    right: {
      x: 32,
      y: 8,
      w: 8,
      h: 8,
    },
    top: {
      x: 40,
      y: 0,
      w: 8,
      h: 8,
    },
    bottom: {
      x: 48,
      y: 0,
      w: 8,
      h: 8,
      flipY: true,
    },
    front: {
      x: 40,
      y: 8,
      w: 8,
      h: 8,
    },
    back: {
      x: 56,
      y: 8,
      w: 8,
      h: 8,
    },
  }],
  torso: [{
    left: {
      x: 28,
      y: 20,
      w: 4,
      h: 12,
    },
    right: {
      x: 16,
      y: 20,
      w: 4,
      h: 12,
    },
    top: {
      x: 20,
      y: 16,
      w: 8,
      h: 4,
    },
    bottom: {
      x: 28,
      y: 16,
      w: 8,
      h: 4,
      flipY: true,
    },
    front: {
      x: 20,
      y: 20,
      w: 8,
      h: 12,
    },
    back: {
      x: 32,
      y: 20,
      w: 8,
      h: 12,
    },
  }],
  armRight: [{
    left: {
      x: 48,
      y: 20,
      w: 4,
      h: 12,
    },
    right: {
      x: 40,
      y: 20,
      w: 4,
      h: 12,
    },
    top: {
      x: 44,
      y: 16,
      w: 4,
      h: 4,
    },
    bottom: {
      x: 48,
      y: 16,
      w: 4,
      h: 4,
      flipY: true,
    },
    front: {
      x: 44,
      y: 20,
      w: 4,
      h: 12,
    },
    back: {
      x: 52,
      y: 20,
      w: 4,
      h: 12,
    },
  }],
  armRightSlim: [{
    left: {
      x: 47,
      y: 20,
      w: 4,
      h: 12,
    },
    right: {
      x: 40,
      y: 20,
      w: 4,
      h: 12,
    },
    top: {
      x: 44,
      y: 16,
      w: 3,
      h: 4,
    },
    bottom: {
      x: 47,
      y: 16,
      w: 3,
      h: 4,
      flipY: true,
    },
    front: {
      x: 44,
      y: 20,
      w: 3,
      h: 12,
    },
    back: {
      x: 51,
      y: 20,
      w: 3,
      h: 12,
    },
  }],
  armLeft: [{
    left: {
      x: 40,
      y: 20,
      w: 4,
      h: 12,
      flipX: true,
    },
    right: {
      x: 48,
      y: 20,
      w: 4,
      h: 12,
      flipX: true,
    },
    top: {
      x: 44,
      y: 16,
      w: 4,
      h: 4,
      flipX: true,
    },
    bottom: {
      x: 48,
      y: 16,
      w: 4,
      h: 4,
      flipX: true,
      flipY: true,
    },
    front: {
      x: 44,
      y: 20,
      w: 4,
      h: 12,
      flipX: true,
    },
    back: {
      x: 52,
      y: 20,
      w: 4,
      h: 12,
      flipX: true,
    },
  }],
  armLeftSlim: [{
    left: {
      x: 40,
      y: 20,
      w: 4,
      h: 12,
      flipX: true,
    },
    right: {
      x: 47,
      y: 20,
      w: 4,
      h: 12,
      flipX: true,
    },
    top: {
      x: 44,
      y: 16,
      w: 3,
      h: 4,
      flipX: true,
    },
    bottom: {
      x: 47,
      y: 16,
      w: 3,
      h: 4,
      flipX: true,
      flipY: true,
    },
    front: {
      x: 44,
      y: 20,
      w: 3,
      h: 12,
      flipX: true,
    },
    back: {
      x: 51,
      y: 20,
      w: 3,
      h: 12,
      flipX: true,
    },
  }],
  legRight: [{
    left: {
      x: 8,
      y: 20,
      w: 4,
      h: 12,
    },
    right: {
      x: 0,
      y: 20,
      w: 4,
      h: 12,
    },
    top: {
      x: 4,
      y: 16,
      w: 4,
      h: 4,
    },
    bottom: {
      x: 8,
      y: 16,
      w: 4,
      h: 4,
      flipY: true,
    },
    front: {
      x: 4,
      y: 20,
      w: 4,
      h: 12,
    },
    back: {
      x: 12,
      y: 20,
      w: 4,
      h: 12,
    },
  }],
  legLeft: [{
    left: {
      x: 0,
      y: 20,
      w: 4,
      h: 12,
      flipX: true,
    },
    right: {
      x: 8,
      y: 20,
      w: 4,
      h: 12,
      flipX: true,
    },
    top: {
      x: 4,
      y: 16,
      w: 4,
      h: 4,
      flipX: true,
    },
    bottom: {
      x: 8,
      y: 16,
      w: 4,
      h: 4,
      flipX: true,
      flipY: true,
    },
    front: {
      x: 4,
      y: 20,
      w: 4,
      h: 12,
      flipX: true,
    },
    back: {
      x: 12,
      y: 20,
      w: 4,
      h: 12,
      flipX: true,
    },
  }],
}, {
  head: [{
    left: {
      x: 16,
      y: 8,
      w: 8,
      h: 8,
    },
    right: {
      x: 0,
      y: 8,
      w: 8,
      h: 8,
    },
    top: {
      x: 8,
      y: 0,
      w: 8,
      h: 8,
    },
    bottom: {
      x: 16,
      y: 0,
      w: 8,
      h: 8,
      flipY: true,
    },
    front: {
      x: 8,
      y: 8,
      w: 8,
      h: 8,
    },
    back: {
      x: 24,
      y: 8,
      w: 8,
      h: 8,
    },
  }, {
    left: {
      x: 48,
      y: 8,
      w: 8,
      h: 8,
    },
    right: {
      x: 32,
      y: 8,
      w: 8,
      h: 8,
    },
    top: {
      x: 40,
      y: 0,
      w: 8,
      h: 8,
    },
    bottom: {
      x: 48,
      y: 0,
      w: 8,
      h: 8,
      flipY: true,
    },
    front: {
      x: 40,
      y: 8,
      w: 8,
      h: 8,
    },
    back: {
      x: 56,
      y: 8,
      w: 8,
      h: 8,
    },
  }],
  torso: [{
    left: {
      x: 28,
      y: 20,
      w: 4,
      h: 12,
    },
    right: {
      x: 16,
      y: 20,
      w: 4,
      h: 12,
    },
    top: {
      x: 20,
      y: 16,
      w: 8,
      h: 4,
    },
    bottom: {
      x: 28,
      y: 16,
      w: 8,
      h: 4,
      flipY: true,
    },
    front: {
      x: 20,
      y: 20,
      w: 8,
      h: 12,
    },
    back: {
      x: 32,
      y: 20,
      w: 8,
      h: 12,
    },
  }, {
    left: {
      x: 28,
      y: 36,
      w: 4,
      h: 12,
    },
    right: {
      x: 16,
      y: 36,
      w: 4,
      h: 12,
    },
    top: {
      x: 20,
      y: 32,
      w: 8,
      h: 4,
    },
    bottom: {
      x: 28,
      y: 32,
      w: 8,
      h: 4,
      flipY: true,
    },
    front: {
      x: 20,
      y: 36,
      w: 8,
      h: 12,
    },
    back: {
      x: 32,
      y: 36,
      w: 8,
      h: 12,
    },
  }],
  armRight: [{
    left: {
      x: 48,
      y: 20,
      w: 4,
      h: 12,
    },
    right: {
      x: 40,
      y: 20,
      w: 4,
      h: 12,
    },
    top: {
      x: 44,
      y: 16,
      w: 4,
      h: 4,
    },
    bottom: {
      x: 48,
      y: 16,
      w: 4,
      h: 4,
      flipY: true,
    },
    front: {
      x: 44,
      y: 20,
      w: 4,
      h: 12,
    },
    back: {
      x: 52,
      y: 20,
      w: 4,
      h: 12,
    },
  }, {
    left: {
      x: 48,
      y: 36,
      w: 4,
      h: 12,
    },
    right: {
      x: 40,
      y: 36,
      w: 4,
      h: 12,
    },
    top: {
      x: 44,
      y: 32,
      w: 4,
      h: 4,
    },
    bottom: {
      x: 48,
      y: 32,
      w: 4,
      h: 4,
      flipY: true,
    },
    front: {
      x: 44,
      y: 36,
      w: 4,
      h: 12,
    },
    back: {
      x: 52,
      y: 36,
      w: 4,
      h: 12,
    },
  }],
  armRightSlim: [{
    left: {
      x: 47,
      y: 20,
      w: 4,
      h: 12,
    },
    right: {
      x: 40,
      y: 20,
      w: 4,
      h: 12,
    },
    top: {
      x: 44,
      y: 16,
      w: 3,
      h: 4,
    },
    bottom: {
      x: 47,
      y: 16,
      w: 3,
      h: 4,
      flipY: true,
    },
    front: {
      x: 44,
      y: 20,
      w: 3,
      h: 12,
    },
    back: {
      x: 51,
      y: 20,
      w: 3,
      h: 12,
    },
  }, {
    left: {
      x: 47,
      y: 36,
      w: 4,
      h: 12,
    },
    right: {
      x: 40,
      y: 36,
      w: 4,
      h: 12,
    },
    top: {
      x: 44,
      y: 32,
      w: 3,
      h: 4,
    },
    bottom: {
      x: 47,
      y: 32,
      w: 3,
      h: 4,
      flipY: true,
    },
    front: {
      x: 44,
      y: 36,
      w: 3,
      h: 12,
    },
    back: {
      x: 51,
      y: 36,
      w: 3,
      h: 12,
    },
  }],
  armLeft: [{
    left: {
      x: 40,
      y: 52,
      w: 4,
      h: 12,
    },
    right: {
      x: 32,
      y: 52,
      w: 4,
      h: 12,
    },
    top: {
      x: 36,
      y: 48,
      w: 4,
      h: 4,
    },
    bottom: {
      x: 40,
      y: 48,
      w: 4,
      h: 4,
      flipY: true,
    },
    front: {
      x: 36,
      y: 52,
      w: 4,
      h: 12,
    },
    back: {
      x: 44,
      y: 52,
      w: 4,
      h: 12,
    },
  }, {
    left: {
      x: 56,
      y: 52,
      w: 4,
      h: 12,
    },
    right: {
      x: 48,
      y: 52,
      w: 4,
      h: 12,
    },
    top: {
      x: 52,
      y: 48,
      w: 4,
      h: 4,
    },
    bottom: {
      x: 56,
      y: 48,
      w: 4,
      h: 4,
      flipY: true,
    },
    front: {
      x: 52,
      y: 52,
      w: 4,
      h: 12,
    },
    back: {
      x: 60,
      y: 52,
      w: 4,
      h: 12,
    },
  }],
  armLeftSlim: [{
    left: {
      x: 39,
      y: 52,
      w: 4,
      h: 12,
    },
    right: {
      x: 32,
      y: 52,
      w: 4,
      h: 12,
    },
    top: {
      x: 36,
      y: 48,
      w: 3,
      h: 4,
    },
    bottom: {
      x: 39,
      y: 48,
      w: 3,
      h: 4,
      flipY: true,
    },
    front: {
      x: 36,
      y: 52,
      w: 3,
      h: 12,
    },
    back: {
      x: 43,
      y: 52,
      w: 3,
      h: 12,
    },
  }, {
    left: {
      x: 55,
      y: 52,
      w: 4,
      h: 12,
    },
    right: {
      x: 48,
      y: 52,
      w: 4,
      h: 12,
    },
    top: {
      x: 52,
      y: 48,
      w: 3,
      h: 4,
    },
    bottom: {
      x: 55,
      y: 48,
      w: 3,
      h: 4,
      flipY: true,
    },
    front: {
      x: 52,
      y: 52,
      w: 3,
      h: 12,
    },
    back: {
      x: 59,
      y: 52,
      w: 3,
      h: 12,
    },
  }],
  legRight: [{
    left: {
      x: 8,
      y: 20,
      w: 4,
      h: 12,
    },
    right: {
      x: 0,
      y: 20,
      w: 4,
      h: 12,
    },
    top: {
      x: 4,
      y: 16,
      w: 4,
      h: 4,
    },
    bottom: {
      x: 8,
      y: 16,
      w: 4,
      h: 4,
      flipY: true,
    },
    front: {
      x: 4,
      y: 20,
      w: 4,
      h: 12,
    },
    back: {
      x: 12,
      y: 20,
      w: 4,
      h: 12,
    },
  }, {
    left: {
      x: 8,
      y: 36,
      w: 4,
      h: 12,
    },
    right: {
      x: 0,
      y: 36,
      w: 4,
      h: 12,
    },
    top: {
      x: 4,
      y: 32,
      w: 4,
      h: 4,
    },
    bottom: {
      x: 8,
      y: 32,
      w: 4,
      h: 4,
      flipY: true,
    },
    front: {
      x: 4,
      y: 36,
      w: 4,
      h: 12,
    },
    back: {
      x: 12,
      y: 36,
      w: 4,
      h: 12,
    },
  }],
  legLeft: [{
    left: {
      x: 24,
      y: 52,
      w: 4,
      h: 12,
    },
    right: {
      x: 16,
      y: 52,
      w: 4,
      h: 12,
    },
    top: {
      x: 20,
      y: 48,
      w: 4,
      h: 4,
    },
    bottom: {
      x: 24,
      y: 48,
      w: 4,
      h: 4,
      flipY: true,
    },
    front: {
      x: 20,
      y: 52,
      w: 4,
      h: 12,
    },
    back: {
      x: 28,
      y: 52,
      w: 4,
      h: 12,
    },
  }, {
    left: {
      x: 8,
      y: 52,
      w: 4,
      h: 12,
    },
    right: {
      x: 0,
      y: 52,
      w: 4,
      h: 12,
    },
    top: {
      x: 4,
      y: 48,
      w: 4,
      h: 4,
    },
    bottom: {
      x: 8,
      y: 48,
      w: 4,
      h: 4,
      flipY: true,
    },
    front: {
      x: 4,
      y: 52,
      w: 4,
      h: 12,
    },
    back: {
      x: 12,
      y: 52,
      w: 4,
      h: 12,
    },
  }],
}]
